<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div v-if="!question.templateImageUrl">
      <div class="question-container">
        <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
        <div class="instruction_title ql-editor p-0 mb-20" v-html="question.formattedTitle"></div>
      </div>
      <div class="instruction_info video-content ql-editor p-0" v-html="question.formattedInformation"></div>
      <div class="row mt-10">
        <div class="col-sm-6 col-md-6 col-lg-6">
          <div v-if="question.imageUrl">
            <img class="img-size" :src="question.imageUrl" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="pl-0 col-md-6 col-lg-6">
          <div class="question-container">
            <span class="step" v-if="showStep"> >Step {{ question.stepSequence }}</span>
            <div class="instruction_title ql-editor p-0 mb-20" v-html="question.formattedTitle"></div>
          </div>
          <div class="instruction_info video-content ql-editor p-0" v-html="question.formattedInformation"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="video-skippable" v-if="videoSkippable">
      <div class="pt-41 screen-title">
        <div class>Skip Video Response Title</div>
        <div v-if="!restrictAddHelp" @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
          <span
            class="add-help-text"
            :style="{
              color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Help
          </span>
        </div>
        <!-- <input type="text" class="form-control input-style br-2" placeholder="Enter title" v-model="question.title"> -->
        <quill-editor class="bg-white mb-30 skippable-title" v-model="question.formattedTitle" :options="editorOptionForContent"></quill-editor>
      </div>
      <!-- help content -->
      <div v-if="isAddHelpEnabled && !restrictAddHelp">
        <h5 class="answer">Help</h5>
        <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
      </div>
      <div class="pt-12">
        <div class>Skip Video Response Content</div>
        <!-- add picture btn start -->
        <div class="th-activity-question-type-custom-scale-edit" data-toggle="modal" data-target="#imageUploadSurvey">
          <span class="step-content-pictur-icon">
            <i class="fa fa-picture-o fs-24" aria-hidden="true"></i>
          </span>
        </div>
        <!-- add picture btn end -->
        <quill-editor class="instruction-screen bg-white mb-30 skippable-content" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption"></quill-editor>
      </div>
    </div>

    <div v-else class="video-non-skippable">
      <div class="pt-41 screen-title">
        <div class>Step Title</div>
        <div v-if="!restrictAddHelp" @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
          <span
            class="add-help-text"
            :style="{
              color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Help
          </span>
        </div>
        <!-- <input type="text" class="form-control input-style br-2" placeholder="Enter title" v-model="question.title"> -->
        <quill-editor class="bg-white mb-30 non-skippable-title" v-model="question.formattedTitle" :options="editorOptionForContent"></quill-editor>
      </div>
      <!-- help content -->
      <div v-if="isAddHelpEnabled && !restrictAddHelp">
        <h5 class="answer">Help</h5>
        <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
      </div>
      <div class="pt-12">
        <div class>Content</div>
        <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
          <span
            class="add-help-text message-text-button-position"
            :style="{
              color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Message
          </span>
        </div>
        <!-- add picture btn start -->
        <div class="th-activity-question-type-custom-scale-edit" data-toggle="modal" data-target="#imageUploadSurvey">
          <span class="step-content-pictur-icon">
            <i class="fa fa-picture-o fs-24" aria-hidden="true"></i>
          </span>
        </div>
        <!-- add pictur btn end -->
        <quill-editor class="instruction-screen bg-white mb-30 non-skippable-content" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption"></quill-editor>
        <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30">
          <div class="col-md-11 p-0">
            <h5 class="mt-10">Message</h5>
            <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
          </div>
          <div class="col-md-1 p-0">
            <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
              <img src="static/img/delete.svg" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-1 mb-80">
      <h5 class="score_text">Score</h5>
      <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model="question.score"><input v-model.number="question.score" type="number" class="integer-plus-minus-input" /> </integer-plusminus>
    </div>

    <!-- Upload Image Model Start -->
    <image-upload-model id="imageUploadSurvey" :question-sequence="question.sequence" :activity-details="activityDetails" @insertedImage="insertImage" />
    <!-- Upload Image Model End -->
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import ImageUploadModel from "./image-upload-model";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepVideoRecording",

  mixins: [activityStepCustomMessage],

  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    },
    videoSkippable: {
      type: Boolean
    },
    restrictAddHelp: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IntegerPlusminus,
    ImageUploadModel,
    quillEditor
  },
  data() {
    return {
      instructionInfo: false,
      editorOption: {
        placeholder: "Enter step content",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOptionForContent: {
        placeholder: "Record your response on camera",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      isAddHelpEnabled: false
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    },
    videoSkippable() {
      this.checkQuillPlaceholders();
    }
  },
  mounted() {
    this.init();
    if (!this.restrictAddHelp) {
      this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    }
    if (this.videoSkippable) {
      this.checkQuillPlaceholders();
    }
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    checkQuillPlaceholders() {
      if (this.videoSkippable) {
        setTimeout(() => {
          //Changing quill Editor Placeholders
          document
            .querySelector(".skippable-title")
            .querySelector(".ql-container")
            .querySelector(".ql-editor")
            .setAttribute("data-placeholder", "Enter your response instead of providing a video recording");

          document
            .querySelector(".skippable-content")
            .querySelector(".ql-container")
            .querySelector(".ql-editor")
            .setAttribute("data-placeholder", "Describe your response");
        }, 100);
      } else {
        setTimeout(() => {
          document
            .querySelector(".non-skippable-title")
            .querySelector(".ql-container")
            .querySelector(".ql-editor")
            .setAttribute("data-placeholder", this.editorOptionForContent.placeholder);

          document
            .querySelector(".non-skippable-content")
            .querySelector(".ql-container")
            .querySelector(".ql-editor")
            .setAttribute("data-placeholder", this.editorOption.placeholder);
        }, 100);
      }
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
        this.$set(this.question, "formattedTitle", "");
        this.$set(this.question, "formattedInformation", "");
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      const title = this.stripHtml(question.formattedTitle);

      if (question.formattedTitle == undefined || title.length == 0) {
        if (this.videoSkippable) {
          errorObj.isValid = false;
          errorObj.msg = "Skip Video Response Title is required.";
          return errorObj;
        } else {
          errorObj.isValid = false;
          errorObj.msg = "Step Title is required.";
          return errorObj;
        }
      }

      if (question.isAddHelpEnabled && !this.restrictAddHelp && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }

      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }

      if (question.hasMaxTimeLimit && question.maxMinutes == 0 && question.maxSeconds == 0) {
        errorObj.isValid = false;
        errorObj.msg = "Max recording time limit must be greater then 0.";
        return errorObj;
      }
      return { isValid: true };
    },
    insertImage(imageData) {
      this.question.imageUrl = imageData.popupImageUrl;
      this.question.imageId = imageData.popupImageId;
      const title = this.question.formattedTitle;

      this.$nextTick(() => {
        if (this.question.formattedInformation.indexOf("<img src") >= 0) {
          this.question.formattedInformation = this.question.formattedInformation.replace(/<img[^>]*src=\"?([^\"]*)\"?([^>]*alt=\"?([^\"]*)\"?)?[^>]*>/g, `<img src="${this.question.imageUrl}" />`);
        } else {
          this.question.formattedInformation += '<img src="' + this.question.imageUrl + '"/>';
        }
        this.question.formattedTitle = " ";
        this.question.formattedTitle = title;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.instruction_title {
  word-break: break-all;
  font-size: 18px;
  font-weight: bold;
}

.instruction_info {
  word-break: break-all;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}

.example {
  color: #4c8ce4;
  cursor: pointer;
}

.file_container1 [type="file"] {
  cursor: pointer;
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 100px;
  height: 40px;
  max-height: 50px;
  //   max-width: 200px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
  left: 0;
}
.file_container1 {
  margin-top: 5px;
  color: #555;
}
.file_container1 [type="file"] {
  cursor: pointer;
}
.file_container_text1 {
  background-color: #ddd;
  padding: 5px;
  width: 100%;
  display: block;
  border-radius: 4px;
  text-align: center;
}

.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}

.integer-plus-minus-input {
  width: 2rem;
  border: none;
}
.add-help-text {
  right: 493px;
  padding: 12px 13px;
  top: -38px;

  &.message-text-button-position {
    right: 549px;
  }
}
.step-content-pictur-icon {
  position: absolute;
  z-index: 9;
  right: 492.5px;
  top: -38px;
  padding: 6.1px 13px;
  background-color: #d3dee3;
  font-size: 20px;
  color: #666669;
  opacity: 0.7;
  font-weight: normal;
  line-height: 1.27;
  cursor: pointer;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

/deep/ .video-content {
  img {
    max-width: 104px;
    display: block;
    margin-top: 8px;
  }
}
</style>
